module.exports = __webpack_public_path__ + "img/8O0A4311.7a2e7bad.png";